<ng-template #matrix let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Price Matrix</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<mat-tab-group>
			<mat-tab label="Product Lines">
				<div class="mb-3 pt-2">
					<div class="row mb-2">
						<div class="col-12 text-right">
							<button mat-raised-button color="accent" (click)="saveMatrix()">SAVE</button>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-12">
							<mat-form-field appearance="outline" class="search-field">
								<mat-label>Search Product Lines</mat-label>
								<input matInput placeholder="Search..." [(ngModel)]="searchText" (input)="filterProductLines()">
								<button matSuffix mat-icon-button aria-label="Clear" *ngIf="searchText" (click)="clearSearch()">
									<mat-icon>clear</mat-icon>
								</button>
							</mat-form-field>
						</div>
					</div>
					<div class="row">
						<div class="col-md-2" *ngFor="let p of filteredProductLines">
							<div class="card product-card" [ngClass]="getCustomerMatrixDiscount(p.line_field) > 0 ? 'product-discounted': ''">
								<h6 class="product-line-title">{{ p.line_field }}</h6>
								<div class="row">
									<div class="col-sm-6">
										<div class="form-group compact-form-group">
											<label for="discount-{{p.line_field}}">Discount</label>
											<input id="discount-{{p.line_field}}" type="text" class="form-control" [value]="getCustomerMatrixDiscount(p.line_field)" (input)="updateCustomerMatrix(p, $event.target.value)">
										</div>
									</div>
									<div class="col-sm-6">
										<div class="form-group compact-form-group">
											<label for="level-{{p.line_field}}">Level</label>
											<input id="level-{{p.line_field}}" type="text" class="form-control" [value]="getCustomerMatrixLevel(p.line_field)" (input)="updateCustomerMatrixLevel(p, $event.target.value)">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</mat-tab>
		<mat-tab label="Brand Discounts">
			<div class="pt-3 pb-2">

				<!-- Toolbar -->
				<div class="brand-toolbar mb-3">
					<div class="d-flex align-items-center flex-wrap" style="gap:0.5rem">
						<mat-form-field appearance="outline" class="mb-0" style="width:200px">
							<mat-label>Filter brands</mat-label>
							<mat-icon matPrefix>search</mat-icon>
							<input matInput [(ngModel)]="brandSearchText" placeholder="Brand name...">
							<button matSuffix mat-icon-button *ngIf="brandSearchText && !addingBrand" (click)="brandSearchText = ''"><mat-icon>clear</mat-icon></button>
						</mat-form-field>
						<span class="brand-count-badge">{{ filteredBrandMatrixData().length }} / {{ brandMatrixData.length }}</span>
					</div>
					<div class="d-flex align-items-center flex-wrap" style="gap:0.5rem">
						<button class="btn btn-success btn-sm" (click)="exportBrandXls()" [disabled]="brandExporting || !brandMatrixData.length" matTooltip="Export XLS">
							<i class="fa fa-file-excel-o"></i>
						</button>
						<button class="btn btn-danger btn-sm" (click)="exportBrandPdf()" [disabled]="brandExporting || !brandMatrixData.length" matTooltip="Export PDF">
							<i class="fa fa-file-pdf-o"></i>
						</button>
						<button mat-raised-button color="primary" (click)="addingBrand = !addingBrand; newBrandDiscount = ''">
							<mat-icon>{{ addingBrand ? 'close' : 'add' }}</mat-icon> {{ addingBrand ? 'Cancel' : 'Add Brand' }}
						</button>
					</div>
				</div>

				<!-- Add brand panel -->
				<div class="brand-add-panel mb-3" *ngIf="addingBrand">
					<div class="d-flex align-items-center flex-wrap mb-2" style="gap:0.5rem">
						<mat-icon class="text-success">add_circle</mat-icon>
						<strong>Add brand discount</strong>
						<mat-form-field appearance="outline" class="mb-0" style="width:200px">
							<mat-label>Filter brands</mat-label>
							<mat-icon matPrefix>search</mat-icon>
							<input matInput [(ngModel)]="brandSearchText" placeholder="Type to filter...">
						</mat-form-field>
						<mat-form-field appearance="outline" class="mb-0" style="width:120px">
							<mat-label>Discount %</mat-label>
							<input matInput type="number" [(ngModel)]="newBrandDiscount" placeholder="0">
							<span matSuffix>%</span>
						</mat-form-field>
					</div>
					<div class="brand-picker-scroll">
						<button mat-stroked-button *ngFor="let b of filteredBrandsForAdd()" class="m-1"
							(click)="addOrUpdateBrandRule(b.manufacturer_id, newBrandDiscount ? +newBrandDiscount : 0)">
							{{ b.name || b.brand_name || b.manufacturer_id }}
						</button>
						<span *ngIf="filteredBrandsForAdd().length === 0" class="text-muted small">No brands available to add.</span>
					</div>
				</div>

				<!-- Brand cards grid -->
				<div class="brand-grid" #brandExportTable>
					<ng-container *ngFor="let row of filteredBrandMatrixData(); trackBy: trackByBrandId">
						<div class="brand-card" [ngClass]="getBrandCardClass(row.discount)">
							<div class="brand-card-header">
								<span class="brand-name" [title]="row.brand_name || row.brand">{{ row.brand_name || row.brand }}</span>
								<span class="brand-id">#{{ row.brand }}</span>
							</div>
							<div class="brand-discount-badge" [ngClass]="getBrandCardClass(row.discount)">
								{{ row.editValue | number:'1.0-2' }}%
							</div>
							<div class="brand-card-edit">
								<div class="input-group input-group-sm">
									<input type="number" class="form-control"
										[(ngModel)]="row.editValue"
										(keydown.enter)="saveBrandCard(row)"
										placeholder="0">
									<div class="input-group-append">
										<button class="btn btn-primary btn-sm" (click)="saveBrandCard(row)" matTooltip="Save">
											<mat-icon class="small-icon">save</mat-icon>
										</button>
									</div>
								</div>
							</div>
							<div class="brand-card-footer">
								<button mat-icon-button color="warn" (click)="removeBrandRule(row.brand)" matTooltip="Remove">
									<mat-icon class="small-icon">delete_outline</mat-icon>
								</button>
							</div>
						</div>
					</ng-container>
				</div>

				<div class="brand-empty-state" *ngIf="!filteredBrandMatrixData().length">
					<mat-icon>label_off</mat-icon>
					<p>No brand discounts{{ brandSearchText && !addingBrand ? ' matching "' + brandSearchText + '"' : '' }}.</p>
				</div>

			</div>
		</mat-tab>
		</mat-tab-group>
	</div>
	<div class="modal-footer"></div>
</ng-template>
<ng-container *ngIf="settingsFrom">
	<form [formGroup]="settingsFrom" (submit)="updateCustomerSettings()">
		<div class="col-12 text-right">
			<button class="ml-auto mr-0" mat-button mat-raised-button [color]="settingsFrom.valid ? 'warn': 'accent' "> <i class="material-icons">save</i> Save</button>
		</div>
		<div class="col-md-12 mt-2 mb-2">
			<button mat-flat-button color="accent" (click)="$event.preventDefault();loadMatrix()">Edit Matrix</button>
			<span class="text-muted small ml-2">Product lines and brand discounts</span>
		</div>
		<div class="row" @grow>
			<div class="col-md-12">
				<mat-slide-toggle formControlName="disabletrans" class="mb-2">Disabled</mat-slide-toggle>
			</div>

			<div class="col-md-12">
				<mat-form-field appearance="outline">
					<mat-label>Username</mat-label>
					<input matInput required value="" formControlName="username">
				</mat-form-field>
			</div>
			<div class="col-md-12 mb-2">
				<mat-slide-toggle formControlName="syncAllCustomerEmails">
					Sync email to branch, statement, invoice &amp; contacts
				</mat-slide-toggle>
			</div>
			<div class="col-md-12">
				<mat-form-field appearance="outline" class="w-100">
					<mat-label>Password</mat-label>
					<input matInput required [type]="hidePassword ? 'password' : 'text'" formControlName="password">
					<button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" matTooltip="{{ hidePassword ? 'Show password' : 'Hide password' }}">
						<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
					</button>
					<button mat-icon-button matSuffix type="button" (click)="generatePassword()" matTooltip="Generate password">
						<mat-icon>vpn_key</mat-icon>
					</button>
				</mat-form-field>
			</div>
			<div class="col-md-12">
				<mat-form-field appearance="outline">
					<mat-label>Customer Type</mat-label>
					<mat-select formControlName="typeid">
						<mat-option *ngFor="let tpe of customertypes" [value]="tpe?.typeid">
							{{tpe.typename}}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="col-md-12">
				<mat-form-field appearance="outline" class="" @grow>
					<mat-label>Sales Person</mat-label>
					<mat-select formControlName="salesman" [(value)]="customer.customer.salesman">
						<mat-option *ngFor="let person of salesman" [value]="person.salesmancode">
							{{ person.salesmancode}} {{person.salesmanname }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="col-md-12">
				<mat-form-field appearance="outline" class="">
					<mat-label>Price List</mat-label>
					<mat-select formControlName="salestype">
						<mat-option *ngFor="let tpe of salestypes" [value]="tpe?.typeabbrev">
							{{ tpe.typeabbrev }} - {{tpe.sales_type}}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="col-md-12" *ngIf="settingsFrom.get('salestype').value == 'O'">
				<mat-form-field appearance="outline" class="">
					<mat-label>Base Price</mat-label>
					<mat-select formControlName="salestype2">
						<mat-option *ngFor="let tpe of salestypes" [value]="tpe?.typeabbrev">
							{{ tpe.typeabbrev }} - {{tpe.sales_type}}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="col-md-12">
				<mat-form-field appearance="outline" class="">
					<mat-label>Discount Level</mat-label>
					<mat-select formControlName="pricelevelprice">
						<mat-option value=""> --- </mat-option>
						<mat-option *ngFor="let tpe of price_levels" [value]="tpe?.price_level_id">
							{{ tpe.price_level_id }} - {{tpe.name}}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="col-md-12">
				<mat-form-field appearance="outline" class="">
					<mat-label>Discount</mat-label>
					<input matInput value="0" type="text" class="text-right" formControlName="discount">
					<mat-icon matSuffix><small>&nbsp;&nbsp;%</small></mat-icon>
				</mat-form-field>
			</div>
			<div class="col-md-12">
			  <!-- Commission Rate Field -->
			  <mat-form-field appearance="outline">
				<mat-label>Commission Rate</mat-label>
				<input
				  matInput
				  value="0"
				  type="text"
				  class="text-right"
				  formControlName="commpct"
				/>
				<mat-icon matSuffix><small>&nbsp;&nbsp;%</small></mat-icon>
			  </mat-form-field>
			</div>

			<div class="col-md-12">
			  <!-- Target Potential Field -->
			  <mat-form-field appearance="outline">
				<mat-label>Target Potential</mat-label>
				<input
				  matInput
				  type="text"
				  class="text-right"
				  formControlName="targetpotential"
				/>
			  </mat-form-field>
			</div>

			<div class="col-md-12">
			  <!-- Target Units Field -->
			  <mat-form-field appearance="outline">
				  <mat-label>Estimated Potential</mat-label>
				  <input
					matInput
					type="number"
					class="text-right"
					formControlName="estimatedpotential"
				  />
				</mat-form-field>
			</div>


			<div *ngIf="clubs.length > 0" class="col-md-12">
				<h5>Clubs Joined</h5>
				<hr>
				<ul *ngIf="customer.clubs_joined && customer.clubs_joined.length > 0">
					<li *ngFor="let club of customer.clubs_joined">
						<div class="spec-label bg-white">
							{{ club.club }}{{ club.accountid ? ' : ' + club.accountid : '' }} <button color="warning" mat-icon-button (click)="$event.preventDefault();removeClub(club)"><mat-icon>remove</mat-icon></button>
						</div>
					</li>
				</ul>
				<div *ngIf="!customer.clubs_joined || customer.clubs_joined.length === 0" class="text-muted mb-2">
					<small>No clubs joined yet</small>
				</div>
				<div class="row">
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="">
							<mat-label>Club to Join</mat-label>
							<mat-select formControlName="clubid">
								<mat-option *ngFor="let tpe of clubs" [value]="tpe?.id" [disabled]="isClubJoined(tpe?.id)">
									{{ tpe.club }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-md-5">
						<mat-form-field appearance="outline" class="">
							<mat-label>Account ID#</mat-label>
							<input matInput type="text" class="text-right" formControlName="clubacctid" placeholder="">
						</mat-form-field>
					</div>
					<div class="col-md-1">
						<button color="primary" mat-icon-button (click)="$event.preventDefault();addClub()" [disabled]="!settingsFrom.get('clubid').value"><mat-icon>save</mat-icon></button>
					</div>
				</div>
			</div>
		</div>
	</form>
</ng-container>